<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        My Opportunities
      </h5>
    </div>

    <loading-spinner v-if="loading"></loading-spinner>

    <ul v-else class="list-group">
      <li v-for="opportunity in opportunities.data" class="list-group-item" style="padding: 10px 0"
          :style="{'background-color': hasDanger(opportunity) ? '#f2dede' : (hasWarning(opportunity) ? '#fcf8e3' : '')}">
        <div style="display: flex; flex-direction: row">
          <div class="text-muted"
               style="flex: 1; font-size: 24px; display: flex; justify-content: center; align-items: center;">
            <i class="fa fa-comments-dollar"></i>
          </div>

          <div style="flex: 7 1 0">
            <router-link :to="'/companies/' + opportunity.attributes.company_id">
              {{ opportunity.attributes.company_name }}
            </router-link>

            <br>

            Value: {{ opportunity.attributes.value | price }}

            <br>

            <i class="text-muted" :style="{color: getDiff(opportunity) < 0 ? '#d9534f' : 'inherit'}">
              {{ getDeadlineDescription(opportunity) }}
            </i>
          </div>

          <div
              style="flex: 1; font-size: 24px; display: flex; justify-content: flex-end; align-items: center;">
            <button type="button" class="btn btn-lg" @click="showOpportunity(opportunity)"
                    style="background-color: transparent">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </li>

      <li v-if="opportunities.meta.total > 10" class="list-group-item" style="padding: 10px 0">
        <pager :pagination="opportunities.meta" @navigate="navigate($event)"></pager>
      </li>

      <li v-if="opportunities.data.length === 0" class="list-group-item text-center" style="padding: 50px;">
        <i class="fa fa-dollar-sign" style="font-size: 96px;"></i>

        <br><br>

        You have no opportunities to convert!
      </li>
    </ul>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import moment from 'moment'
import notify from '@/notify'
import store from '@/store'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import Pager from '@/components/Lists/Pager'

export default {
  components: {LoadingSpinner, Pager},

  data() {
    return {
      opportunities: null,

      loading: true,
      shared: store,
      page: 1
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    navigate(page) {
      this.page = page

      this.load()
    },

    load() {
      http.get('/api/v2/opportunities', {sort: 'conversion_expected_at,id', page_size: 10, page: this.page, 'filter[status]': 'open', 'filter[user_id]': this.shared.user.id})
          .then(response => {
            this.opportunities = response.data

            this.loading = false
          })
    },

    close(opportunity) {
      modal.confirm('Are you sure that you want to close the opportunity?', () => {
        http.post('/api/v2/opportunities/' + opportunity.id + '/close')
            .then(() => {
              notify.success('The opportunity was closed')

              this.navigate(1)
            })
      })
    },

    getDeadlineDescription(opportunity) {
      let diff = this.getDiff(opportunity)

      if (diff === 0) {
        return 'Today'
      }

      if (diff === 1) {
        return 'Tomorrow'
      }

      if (diff === -1) {
        return 'Yesterday'
      }

      if (diff > 1) {
        return 'In ' + diff + ' days'
      }

      if (diff < 1) {
        return Math.abs(diff) + ' days ago'
      }
    },

    showOpportunity(opportunity) {
      this.$router.push('/companies/' + opportunity.attributes.company_id + '/opportunities/' + opportunity.id)
    },

    getDiff(opportunity) {
      return moment(opportunity.attributes.conversion_expected_at).diff(moment().startOf('day'), 'days')
    },

    hasWarning(opportunity) {
      return moment().subtract(20, 'days').isAfter(opportunity.attributes.created_at)
    },

    hasDanger(opportunity) {
      return moment().subtract(30, 'days').isAfter(opportunity.attributes.created_at)
    }
  }
}
</script>
